export enum StatusHistorical {
	Mandatory = "MANDATORY",
	MandatoryForSubmission = "MANDATORY_FOR_SUBMISSION",
	Optional = "OPTIONAL",
}
